import React from "react";

const CourseHandbook = () => {
  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "30px",
        }}
      >
        <a
          href="/assets/pdf/Learner_Handbook.pdf"
          download="Learner_Handbook.pdf"
          style={{
            marginTop: "40px",
            padding: "14px 24px",
            borderRadius: "8px",
            backgroundColor: "#d62828",
            color: "#fff",
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Download Learner Handbook PDF
        </a>
      </div>
    </>
  );
};

export default CourseHandbook;
